// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__2QCWo","titleWrapper":"styles_titleWrapper__1BboH","title":"styles_title__rmVPH","label":"styles_label__uNrSJ"};